import React from 'react'
import Link from 'gatsby-link'

//  Styles
import styles from './Button.module.scss';

const Button = ( props ) => (
  <div>
  { props.to ?
    <Link to={ props.to } className={ props.className ? styles[props.className] : styles.button__primary }>{ props.text }</Link>
  :
  <a href={ props.href } className={ props.className ? styles[props.className] : styles.button__primary }>{ props.text }</a>
  }
  </div>
)

export default Button


// WEBPACK FOOTER //
// ./src/components/Button/Button.js